<script>
// SZ: TimeAgo agora exibe APENAS o timestamp da última atividade no formato
// estilo WhatsApp (formatChatListDate). Mantém timer reativo + tooltip
// detalhado pra hover. Negrito quando `bold=true` (mensagem nova).
const MINUTE_IN_MILLI_SECONDS = 60000;
const HOUR_IN_MILLI_SECONDS = MINUTE_IN_MILLI_SECONDS * 60;
const DAY_IN_MILLI_SECONDS = HOUR_IN_MILLI_SECONDS * 24;

import {
  dynamicTime,
  dateFormat,
  formatChatListDate,
} from 'shared/helpers/timeHelper';

export default {
  name: 'TimeAgo',
  props: {
    isAutoRefreshEnabled: {
      type: Boolean,
      default: true,
    },
    lastActivityTimestamp: {
      type: [String, Date, Number],
      default: '',
    },
    createdAtTimestamp: {
      type: [String, Date, Number],
      default: '',
    },
    // SZ: aplica negrito quando há mensagem não lida (passado pelo ConversationCard).
    bold: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // SZ: tick reativo só pra forçar reavaliação do computed quando o
      // tempo passa (ex.: "14:32" hoje → "Ontem" amanhã).
      nowTick: Date.now(),
      timer: null,
    };
  },
  computed: {
    // SZ: formatação WhatsApp-style (Hoje=hora, Ontem, dia da semana, dd/MM, dd/MM/yyyy).
    // nowTick é lido pra que o timer reativo dispare reavaliação.
    lastActivityFormatted() {
      // eslint-disable-next-line no-unused-expressions
      this.nowTick;
      return formatChatListDate(this.lastActivityTimestamp);
    },
    // Tooltip mantém o detalhe ("Última atividade: X horas atrás · Criada Y dias atrás").
    tooltipText() {
      const createdRel = dynamicTime(this.createdAtTimestamp);
      const lastRel = dynamicTime(this.lastActivityTimestamp);
      const createdTimeDiff = Date.now() - this.createdAtTimestamp * 1000;
      const isCreatedOld = createdTimeDiff > DAY_IN_MILLI_SECONDS * 30;
      const createdStr = isCreatedOld
        ? `${this.$t('CHAT_LIST.CHAT_TIME_STAMP.CREATED.OLDEST')} ${dateFormat(this.createdAtTimestamp)}`
        : `${this.$t('CHAT_LIST.CHAT_TIME_STAMP.CREATED.LATEST')} ${createdRel}`;
      const lastTimeDiff = Date.now() - this.lastActivityTimestamp * 1000;
      const isLastOld = lastTimeDiff > DAY_IN_MILLI_SECONDS * 30;
      const lastStr = isLastOld
        ? `${this.$t('CHAT_LIST.CHAT_TIME_STAMP.LAST_ACTIVITY.NOT_ACTIVE')} ${dateFormat(this.lastActivityTimestamp)}`
        : `${this.$t('CHAT_LIST.CHAT_TIME_STAMP.LAST_ACTIVITY.ACTIVE')} ${lastRel}`;
      return `${createdStr}\n${lastStr}`;
    },
  },
  mounted() {
    if (this.isAutoRefreshEnabled) {
      this.createTimer();
    }
  },
  unmounted() {
    clearTimeout(this.timer);
  },
  methods: {
    createTimer() {
      this.timer = setTimeout(() => {
        this.nowTick = Date.now();
        this.createTimer();
      }, this.refreshTime());
    },
    // Intervalo dinâmico — recente atualiza mais rápido (1min), antigo só de hora em hora.
    refreshTime() {
      const timeDiff = Date.now() - this.lastActivityTimestamp * 1000;
      if (timeDiff > DAY_IN_MILLI_SECONDS) return DAY_IN_MILLI_SECONDS;
      if (timeDiff > HOUR_IN_MILLI_SECONDS) return HOUR_IN_MILLI_SECONDS;
      return MINUTE_IN_MILLI_SECONDS;
    },
  },
};
</script>

<template>
  <div
    v-tooltip.top="{
      content: tooltipText,
      delay: { show: 1000, hide: 0 },
      hideOnClick: true,
    }"
    class="ml-auto leading-4 text-xxs"
    :class="bold ? 'font-bold text-n-slate-12' : 'text-n-slate-10 hover:text-n-slate-11'"
    :style="bold ? 'font-weight: 700' : ''"
  >
    <span>{{ lastActivityFormatted }}</span>
  </div>
</template>
